export const comparisonTypes = [
  {
    key: 'CONTAINS',
    value: 'CONTAINS',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false,
    freeTextSearch: true
  },
  {
    key: 'CONTAINS',
    value: 'DOES_NOT_CONTAIN',
    isNegativeMatch: true,
    forGeoTags: false,
    forMultipleValues: false,
    freeTextSearch: true
  },
  {
    key: 'BEGINS_WITH',
    value: 'BEGINS_WITH',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false,
    freeTextSearch: true
  },
  {
    key: 'BEGINS_WITH',
    value: 'DOES_NOT_BEGIN_WITH',
    isNegativeMatch: true,
    forGeoTags: false,
    forMultipleValues: false,
    freeTextSearch: true
  },
  {
    key: 'GREATER_THAN',
    value: 'GREATER_THAN',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false,
    useNumericalValue: true,
    freeTextSearch: true
  },
  {
    key: 'LESS_THAN',
    value: 'LESS_THAN',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false,
    useNumericalValue: true,
    freeTextSearch: true
  },
  {
    key: 'EQUALS',
    value: 'EQUALS_SINGLE_VALUE',
    isNegativeMatch: false,
    forMultipleValues: false,
    defaultComparisonType: true
  },
  {
    key: 'EQUALS',
    value: 'EQUALS_MULTIPLE_VALUES',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: true,
    hideInReporting: true,
    forBulkTags: true
  },
  {
    key: 'EQUALS',
    value: 'DOES_NOT_EQUAL_SINGLE_VALUE',
    isNegativeMatch: true,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'EQUALS',
    value: 'DOES_NOT_EQUAL_MULTIPLE_VALUES',
    isNegativeMatch: true,
    forGeoTags: false,
    forMultipleValues: true,
    hideInReporting: true,
    forBulkTags: true
  },
  {
    key: 'EQUALS',
    value: 'EQUALS',
    isNegativeMatch: false,
    hideInReporting: true,
    forGeoTags: true,
    forMultipleValues: false,
    defaultComparisonType: false
  },
  {
    key: 'IN',
    value: 'DOES_NOT_EQUAL',
    isNegativeMatch: true,
    hideInReporting: true,
    forGeoTags: true,
    forMultipleValues: false,
    defaultComparisonType: false
  },
  {
    key: 'EXISTS',
    value: 'EXISTS',
    isNegativeMatch: false,
    hideInReporting: false,
    forGeoTags: false,
    forBulkTags: false,
    forMultipleValues: false
  },
  {
    key: 'EXISTS',
    value: 'DOES_NOT_EXIST',
    isNegativeMatch: true,
    hideInReporting: false,
    forGeoTags: false,
    forBulkTags: false,
    forMultipleValues: false
  }
];

export const bidAdjustmentsComparisonTypes = [
  //TODORTB talk to Dima about 'forMultipleValues' field, it is not implemented in the API yet
  ...comparisonTypes.filter(ct => !ct.forMultipleValues),
  {
    key: 'REQUIRED',
    value: 'REQUIRED',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'MATCH',
    value: 'WILDCARD_MATCH',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'MATCH',
    value: 'WILDCARD_DOES_NOT_MATCH',
    isNegativeMatch: true,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'REGEX',
    value: 'REGEX_MATCH',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'REGEX',
    value: 'REGEX_DOES_NOT_MATCH',
    isNegativeMatch: true,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'TAG_SET',
    value: 'HAS_NO_VALUE',
    isNegativeMatch: true,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'BULK',
    value: 'BULK',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'ALWAYS',
    value: 'ALWAYS',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'NUMBER',
    value: 'IS_NUMBER',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'NUMBER',
    value: 'IS_NOT_NUMBER',
    isNegativeMatch: true,
    forGeoTags: false,
    forMultipleValues: false
  },
  {
    key: 'TAG_SET',
    value: 'HAS_VALUE',
    isNegativeMatch: false,
    forGeoTags: false,
    forMultipleValues: false
  }
];

export const bidAdjustmentsOperationTypes = [
  {
    key: 'ADD',
    value: 'ADD'
  },
  {
    key: 'SUBTRACT',
    value: 'SUBTRACT'
  },
  {
    key: 'MULTIPLY',
    value: 'MULTIPLY'
  },
  {
    key: 'OVERRIDE',
    value: 'OVERRIDE'
  },
  {
    key: 'OVERRIDE_FROM_TAG',
    value: 'OVERRIDE_FROM_TAG'
  },
  {
    key: 'REJECT',
    value: 'REJECT'
  }
];

export const rangeComparisonType = [{
  key: 'Between',
  value: 'Is between',
}];

export const defaultComparisonType = comparisonTypes.find(
  (type) => {
    return type.defaultComparisonType;
  }
);

export const geoComparisonTypes = comparisonTypes.filter(
  (type) => {
    return !!type.forGeoTags;
  }
);

export const geoTagsIds = [
  {
    tagId: 'Geo:SubDivision',
    stateValueProperty: 'name'
  },
  {
    tagId: 'Geo:SubDivisionCode',
    stateValueProperty: 'name'
  },
  {
    tagId: 'InboundNumber:State',
    stateValueProperty: 'abbreviation'
  },
  {
    tagId: 'Address:State',
    stateValueProperty: 'abbreviation'
  },
  {
    tagId: 'Lookup:gatherState',
    stateValueProperty: 'abbreviation'
  },
  {
    tagId: 'Lookup:geoState',
    stateValueProperty: 'abbreviation'
  },
  {
    tagId: 'Lookup:icpState',
    stateValueProperty: 'abbreviation'
  },
  {
    tagId: 'Lookup:userState',
    stateValueProperty: 'abbreviation'
  }
];

export const geoProvincesTagsIds = [
  {
    tagId: 'InboundNumber:Province',
    provinceValueProperty: 'name'
  },
  {
    tagId: 'InboundNumber:ProvinceCode',
    provinceValueProperty: 'abbreviation'
  }
];

export const availableTags = [
  { tagType: 'PlacementInfo', tagName: 'PlacementId', tagSource: 'JSTag' },
  { tagType: 'PlacementInfo', tagName: 'LandingPageId', tagSource: 'JSTag' },
  {
    tagType: 'PlacementInfo',
    tagName: 'LandingPageVersion',
    tagSource: 'JSTag'
  },
  { tagType: 'PlacementInfo', tagName: 'SearchTerm', tagSource: 'JSTag' },
  { tagType: 'PlacementInfo', tagName: 'SearchKeyWord', tagSource: 'JSTag' },
  { tagType: 'Time', tagName: 'UTCHour', tagSource: 'Call' },
  { tagType: 'Time', tagName: 'UTCMinute', tagSource: 'Call' },
  { tagType: 'Time', tagName: 'UTCSecond', tagSource: 'Call' },
  { tagType: 'Date', tagName: 'UTCWeekDay', tagSource: 'Call' },
  { tagType: 'Date', tagName: 'UTCDay', tagSource: 'Call' },
  { tagType: 'Date', tagName: 'UTCMonth', tagSource: 'Call' },
  { tagType: 'Date', tagName: 'UTCYear', tagSource: 'Call' },
  { tagType: 'Publisher', tagName: 'Name', tagSource: 'Call' },
  { tagType: 'Publisher', tagName: 'Company', tagSource: 'Call' },
  { tagType: 'Publisher', tagName: 'Id', tagSource: 'Call' },
  { tagType: 'Publisher', tagName: 'SubId', tagSource: 'Call' },
  { tagType: 'Publisher', tagName: 'ReplacementNumber', tagSource: 'Call' },
  { tagType: 'Campaign', tagName: 'Name', tagSource: 'Call' },
  { tagType: 'Campaign', tagName: 'Id', tagSource: 'Call' },
  { tagType: 'Campaign', tagName: 'TrackingId', tagSource: 'Call' },
  { tagType: 'InboundNumber', tagName: 'Number', tagSource: 'Call' },
  { tagType: 'InboundNumber', tagName: 'CountryCode', tagSource: 'Call' },
  { tagType: 'InboundNumber', tagName: 'CountryDigits', tagSource: 'Call' },
  { tagType: 'InboundNumber', tagName: 'AreaCode', tagSource: 'Call' },
  { tagType: 'InboundNumber', tagName: 'Region', tagSource: 'Call' },
  {
    tagType: 'InboundNumber',
    tagName: 'IsPhoneNumberValid',
    tagSource: 'Call'
  },
  { tagType: 'InboundNumber', tagName: 'Prefix', tagSource: 'Call' },
  { tagType: 'InboundNumber', tagName: 'Suffix', tagSource: 'Call' },
  { tagType: 'DialedNumber', tagName: 'Number', tagSource: 'Call' },
  { tagType: 'DialedNumber', tagName: 'Name', tagSource: 'Call' },
  { tagType: 'CallLength', tagName: 'Total', tagSource: 'Call' },
  { tagType: 'CallLength', tagName: 'FromConnect', tagSource: 'Call' },
  { tagType: 'CallLength', tagName: 'FromDial', tagSource: 'Call' },
  { tagType: 'Target', tagName: 'Name', tagSource: 'Connection' },
  { tagType: 'Target', tagName: 'Id', tagSource: 'Connection' },
  { tagType: 'Target', tagName: 'SubId', tagSource: 'Connection' },
  { tagType: 'Buyer', tagName: 'Id', tagSource: 'Connection' },
  { tagType: 'Buyer', tagName: 'Name', tagSource: 'Connection' },
  { tagType: 'Buyer', tagName: 'SubId', tagSource: 'Connection' },
  { tagType: 'Recording', tagName: 'RecordingUrl', tagSource: 'Call' },
  { tagType: 'Geo', tagValue: '', tagName: 'Country', tagSource: 'JSTag' },
  { tagType: 'Geo', tagValue: '', tagName: 'CountryCode', tagSource: 'JSTag' },
  { tagType: 'Geo', tagValue: '', tagName: 'SubDivision', tagSource: 'JSTag' },
  {
    tagType: 'Geo',
    tagValue: '',
    tagName: 'SubDivisionCode',
    tagSource: 'JSTag'
  },
  { tagType: 'Geo', tagValue: '', tagName: 'City', tagSource: 'JSTag' },
  { tagType: 'Geo', tagValue: '', tagName: 'ZipCode', tagSource: 'JSTag' },
  { tagType: 'Geo', tagValue: '', tagName: 'Latitude', tagSource: 'JSTag' },
  { tagType: 'Geo', tagValue: '', tagName: 'Longitude', tagSource: 'JSTag' },
  {
    tagType: 'Technology',
    tagValue: '',
    tagName: 'IsMobile',
    tagSource: 'JSTag'
  },
  {
    tagType: 'Technology',
    tagValue: '',
    tagName: 'UserAgentString',
    tagSource: 'JSTag'
  },
  { tagType: 'Technology', tagValue: '', tagName: 'OS', tagSource: 'JSTag' },
  {
    tagType: 'Technology',
    tagValue: '',
    tagName: 'OSVersion',
    tagSource: 'JSTag'
  },
  {
    tagType: 'Technology',
    tagValue: '',
    tagName: 'Browser',
    tagSource: 'JSTag'
  },
  {
    tagType: 'Technology',
    tagValue: '',
    tagName: 'BrowserVersion',
    tagSource: 'JSTag'
  },
  {
    tagType: 'Technology',
    tagValue: '',
    tagName: 'IPAddress',
    tagSource: 'JSTag'
  },
  {
    tagType: 'ConnectionInfo',
    tagValue: '',
    tagName: 'ISP',
    tagSource: 'JSTag'
  },
  {
    tagType: 'ConnectionInfo',
    tagValue: '',
    tagName: 'OrganizationName',
    tagSource: 'JSTag'
  },
  {
    tagType: 'ConnectionInfo',
    tagValue: '',
    tagName: 'AutonomousName',
    tagSource: 'JSTag'
  },
  {
    tagType: 'ConnectionInfo',
    tagValue: '',
    tagName: 'AutonomousSystemNumber',
    tagSource: 'JSTag'
  },
  {
    tagType: 'RequestInfo',
    tagValue: '',
    tagName: 'ReferrerPage',
    tagSource: 'JSTag'
  },
  {
    tagType: 'RequestInfo',
    tagValue: '',
    tagName: 'LandingPageUrl',
    tagSource: 'JSTag'
  },
  { tagType: 'ScreenInfo', tagValue: '', tagName: 'Width', tagSource: 'JSTag' },
  {
    tagType: 'ScreenInfo',
    tagValue: '',
    tagName: 'Height',
    tagSource: 'JSTag'
  },
  {
    tagType: 'ScreenInfo',
    tagValue: '',
    tagName: 'PixelDensity',
    tagSource: 'JSTag'
  },
  {
    tagType: 'ScreenInfo',
    tagValue: '',
    tagName: 'ColorDepth',
    tagSource: 'JSTag'
  },
  { tagType: 'InboundNumber', tagName: 'State', tagSource: 'Call' },
  { tagType: 'InboundNumber', tagName: 'Province', tagSource: 'Call' },
  { tagType: 'InboundNumber', tagName: 'ProvinceCode', tagSource: 'Call' },
  { tagType: 'wer', tagValue: '', tagName: 'eee', tagSource: 'User' }
];
